import React, { useState } from "react";
import {
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaLinkedinIn,
  FaInstagram,
  FaFacebookF,
  FaYoutube,
  FaWhatsapp,
} from "react-icons/fa";

const ContactForm = () => {
  const COLORS = {
    bgPrimary: "#0B1C2D",
    bgSecondary: "#13293D",
    gold: "#C6A75E",
    textLight: "#EAEAEA",
  };

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, subject, message } = formData;
    const whatsappMessage = `New Contact Form Submission:%0AName: ${name}%0AEmail: ${email}%0ASubject: ${subject}%0AMessage: ${message}`;
    const adminNumber = "919625975135";
    window.open(`https://wa.me/${adminNumber}?text=${whatsappMessage}`, "_blank", "noopener noreferrer");
    setFormData({ name: "", email: "", subject: "", message: "" });
  };

  return (
    <section 
      style={{ backgroundColor: COLORS.bgPrimary }} 
      className="py-24 px-6 md:px-12 lg:px-20 relative"
    >
      <div className="max-w-7xl mx-auto">
        <div className="mb-16">
          <div className="flex items-center gap-4 mb-4">
            <div className="h-[2px] w-16" style={{ backgroundColor: COLORS.gold }}></div>
            <span style={{ color: COLORS.gold }} className="uppercase tracking-widest text-sm font-bold">
              Legal Support
            </span>
          </div>
          <h2 className="text-5xl md:text-7xl text-white font-bold leading-tight">
            Contact <span className="text-white/40 font-light">Nyaysakti.</span>
          </h2>
        </div>

        <div className="grid lg:grid-cols-12 gap-10">
          {/* LEFT CARD */}
          <div className="lg:col-span-5 space-y-8">
            <div 
              className="p-10 md:p-12 rounded-3xl border border-white/10 shadow-2xl h-full flex flex-col justify-between"
              style={{ backgroundColor: COLORS.bgSecondary }}
            >
              <div className="space-y-12">
                {/* Office Chamber */}
                <div className="flex gap-6 items-start">
                  <div className="p-4 rounded-2xl bg-white/5 border border-white/10">
                    <FaMapMarkerAlt size={24} style={{ color: COLORS.gold }} />
                  </div>
                  <div>
                    <h4 className="text-white text-xl font-bold mb-2">Office Chamber</h4>
                    <p className="text-gray-400 text-lg leading-relaxed">
                      Chamber No. 652, 6th Floor, Lawyers Block, <br />
                      Saket Court Complex, New Delhi - 110017
                    </p>
                  </div>
                </div>

                {/* Direct Contact */}
                <div className="flex gap-6 items-start">
                  <div className="p-4 rounded-2xl bg-white/5 border border-white/10">
                    <FaPhoneAlt size={24} style={{ color: COLORS.gold }} />
                  </div>
                  <div>
                    <h4 className="text-white text-xl font-bold mb-2">Direct Contact</h4>
                    <p className="text-white text-2xl font-bold mb-1">+9 1 9625975135</p>
                    <p className="text-gray-400 text-lg">arunchaudhri1258@gmail.com</p>
                  </div>
                </div>

                {/* WhatsApp link */}
                <a 
                  href="https://wa.me/919625975135"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-4 p-4 rounded-2xl border border-[#C6A75E]/30 bg-[#C6A75E]/5 hover:bg-[#C6A75E]/10 transition-all group"
                >
                  <FaWhatsapp size={28} style={{ color: COLORS.gold }} />
                  <span className="text-white font-bold text-lg group-hover:translate-x-1 transition-transform">
                    Chat with an Expert on WhatsApp
                  </span>
                </a>

                {/* Social Media Buttons BELOW WhatsApp */}
                <div className="flex gap-5 pt-4">
                  {[FaFacebookF, FaLinkedinIn, FaInstagram, FaYoutube].map((Icon, i) => (
                    <button 
                      key={i} 
                      type="button"
                      aria-label="Social Link"
                      className="w-12 h-12 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center text-white hover:bg-[#C6A75E] hover:text-[#0B1C2D] transition-all"
                    >
                      <Icon size={18} />
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* RIGHT FORM */}
          <div className="lg:col-span-7">
            <form onSubmit={handleSubmit} className="bg-white/5 p-10 md:p-14 rounded-3xl border border-white/10 backdrop-blur-sm space-y-10">
              <h3 className="text-3xl text-white font-bold mb-6">Send a Message</h3>
              <div className="grid md:grid-cols-2 gap-8">
                <div className="space-y-3">
                  <label className="text-gray-300 text-sm font-bold uppercase tracking-wider">Full Name</label>
                  <input
                    type="text" name="name" required placeholder="Enter your name" value={formData.name} onChange={handleChange}
                    className="w-full bg-[#13293D] border border-white/10 rounded-xl px-6 py-4 text-white text-lg focus:outline-none focus:border-[#C6A75E] transition-all"
                  />
                </div>
                <div className="space-y-3">
                  <label className="text-gray-300 text-sm font-bold uppercase tracking-wider">Email Address</label>
                  <input
                    type="email" name="email" required placeholder="Enter your email" value={formData.email} onChange={handleChange}
                    className="w-full bg-[#13293D] border border-white/10 rounded-xl px-6 py-4 text-white text-lg focus:outline-none focus:border-[#C6A75E] transition-all"
                  />
                </div>
              </div>
              <div className="space-y-3">
                <label className="text-gray-300 text-sm font-bold uppercase tracking-wider">Subject</label>
                <input
                  type="text" name="subject" placeholder="What is this regarding?" value={formData.subject} onChange={handleChange}
                  className="w-full bg-[#13293D] border border-white/10 rounded-xl px-6 py-4 text-white text-lg focus:outline-none focus:border-[#C6A75E] transition-all"
                />
              </div>
              <div className="space-y-3">
                <label className="text-gray-300 text-sm font-bold uppercase tracking-wider">Your Message</label>
                <textarea
                  name="message" rows="4" required placeholder="Describe your legal matter..." value={formData.message} onChange={handleChange}
                  className="w-full bg-[#13293D] border border-white/10 rounded-xl px-6 py-5 text-white text-lg focus:outline-none focus:border-[#C6A75E] transition-all resize-none"
                ></textarea>
              </div>
              <button
                type="submit"
                style={{ backgroundColor: COLORS.gold, color: COLORS.bgPrimary }}
                className="w-full py-5 rounded-xl font-black uppercase tracking-[0.2em] text-lg hover:scale-[1.01] active:scale-[0.98] transition-all shadow-xl shadow-[#C6A75E]/10"
              >
                Submit Consultation Request
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;